import type { WSChatMessage } from "../../types";

const GROUP_WINDOW_MS = 60 * 1000;

export function formatChatTime(value: string) {
  return new Date(value).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function shouldGroupChatMessages(left?: WSChatMessage, right?: WSChatMessage) {
  if (!left || !right || left.senderId !== right.senderId) return false;
  return Math.abs(new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime()) <= GROUP_WINDOW_MS;
}

export function getChatReplyLabel(
  message: WSChatMessage,
  mine: boolean,
  viewerUserId: string,
  partnerName: string,
) {
  const repliedToMine = message.replyToSenderId === viewerUserId;
  if (mine) return repliedToMine ? "You replied to yourself" : `You replied to ${partnerName}`;
  return repliedToMine ? `${partnerName} replied to you` : `${partnerName} replied to self`;
}

export function getChatGroupPosition(
  groupedWithPrevious: boolean,
  groupedWithNext: boolean,
): "single" | "first" | "middle" | "last" {
  if (groupedWithPrevious && groupedWithNext) return "middle";
  if (groupedWithPrevious) return "last";
  if (groupedWithNext) return "first";
  return "single";
}

type AdminChatMessage = {
  id: string;
  senderId: string;
  content: string;
  createdAt: string;
  replyToId: string | null;
};

export function toWsChatMessages(messages: AdminChatMessage[]): WSChatMessage[] {
  const byId = new Map(messages.map((message) => [message.id, message]));

  return messages.map((message) => {
    const replyTarget = message.replyToId ? byId.get(message.replyToId) : undefined;
    return {
      id: message.id,
      senderId: message.senderId,
      content: message.content,
      createdAt: message.createdAt,
      isRead: true,
      replyToId: message.replyToId ?? undefined,
      replyToContent: replyTarget?.content,
      replyToSenderId: replyTarget?.senderId,
    };
  });
}
